import type Competence from "constants/Competence";
import type { Epci } from "./Epci";
import type { MinimalPerimetre } from "./Perimetre";

export interface BaseTransfert {
  id: string;
  code: string;

  idPerimetre: string;
  libellePerimetre: string;

  dateDebut: string;
  datePremierTransfert: string;

  dateAssembleeGenerale?: string;
  dateDeliberation?: string;
  dateFin?: string;
}

export interface TransfertDto extends BaseTransfert {
  bassinVersant?: string;

  idCommune: string;
  libelleCommune: string;

  competence: Competence;

  idTerritoire: string;
  libelleTerritoire: string;

  idEpci?: string;
  libelleEpci?: string;

  affectationsCommunesAssocieesDeleguees?: Array<string>;
}

export interface Transfert extends TransfertDto {
  perimetre: MinimalPerimetre;
  epci?: Epci;
}

// TODO: trouver un meilleur nom pour ces transferts
export interface TransfertCEA extends BaseTransfert {
  isDeleted: boolean;
  competence: string;
  typeAdhesion: string;
  entiteTransferante: EntiteTransferante;
  lieuParticulier: LieuParticulier;
  isFromCEA: boolean;
}

export interface EntiteTransferante {
  id: string;
  type: string;
  libelle: string;
}

export interface LieuParticulier {
  id: string;
  libelle: string;
}

export interface TransfertCreateData {
  code: string;
  idPerimetre: string;
  bassinVersant?: string;
  idEpci?: string;
  dateDebut: string;
  dateDeliberation: string;
  dateAssembleeGenerale: string;
  raisonCreation: RaisonCreationTransfert;
}

export interface TransfertChangeEpciData {
  idEpci: string | undefined;
  dateEffet: string;
  transfertIds: Array<string>;
}

export interface ModificationDatesData {
  transfertIds: Array<string>;
  dateDebut?: string;
  dateDeliberation?: string;
  datePremierTransfert?: string;
  dateAssembleeGenerale?: string;
}

export interface TransfertChangePerimetreData {
  idPerimetre: string;
  dateEffet: string;
  transfertIds: Array<string>;
}

/** Liste des raisons de création de transferts disponibles */
export const RaisonCreationTransfertLibelles = [
  "Nouveau transfert",
  "Transfert Complémentaire",
  "Changement de type de transfert",
  "Correction d'une erreur de saisie pour un futur transfert",
  "Correction d'une erreur de saisie dans le passé",
  "Retour en arrière suite à un transfert non abouti",
] as const;
export type RaisonCreationTransfert = (typeof RaisonCreationTransfertLibelles)[number];

export interface SuppressionTransfertData {
  idCommune: string;
  idTransfert: string;
}

export type SuppressionTransfertsData = Array<SuppressionTransfertData>;
